<div class="text-center">
    <H4>Votre dossier été sauvegardé en l'état</H4>
    <BR>
    <H5>
        Votre dossier ne sera pas transmis à notre service Achats tant qu'il ne sera pas complet.
        <BR>
        Vous pourrez le finaliser ultérieurement en vous reconnectant avec les identifiants suivants :
        <BR>
        <div class="row align-items-center">
            <div class="col-4 text-right">Identifiant :</div>
            <div class="col-4">
                <input class="form-control text-center" [ngModel]="newExtUser.Email" disabled>
            </div>
        </div>
        <BR>
        Un mail contenant un mot de passe provisoire a été envoyé à l'adresse email que vous avez renseignée.
    </H5>
</div>